<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <CCol>
            <strong>{{ $lang.machine.crud.detail }}</strong>
            <back-to-list></back-to-list>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <span @click="selected = 'MachineDetail'">
              <CTab>
                <template slot="title">
                  {{ $lang.machine.crud.detail }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'MachineMedia'">
              <CTab>
                <template slot="title">
                  {{ $lang.machine.crud.view_media }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'MachineResponse'">
              <CTab>
                <template slot="title">
                  {{ $lang.machine.crud.view_response }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'MachineReport'">
              <CTab>
                <template slot="title">
                  {{ $lang.machine.crud.view_report }}
                </template>
              </CTab>
            </span>
          </CTabs>
          <component
              :is="selected"
              @changeSelected="getTab($event)"
              style="margin-top: 20px"
          ></component>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import {Mixin} from "/src/mixins/index.js";
import MachineMedia from "./tab/MachineMedia";
import MachineDetail from "./tab/MachineDetail";
import MachineReport from "./tab/MachineReport";
import MachineResponse from "./tab/MachineResponse";
import BackToList from "/src/views/backToList.vue";

export default {
  name: "MachineView",
  mixins: [Mixin],
  components: {
    MachineDetail,
    MachineMedia,
    MachineReport,
    MachineResponse,
    BackToList,
  },
  data() {
    return {
      userId: "",
      tabs: ["MachineDetail", "MachineMedia", "MachineReport", "MachineResponse", "MachineResource"],
      selected: "MachineDetail",
      currentId: "",
      backToListFlag: "",
    };
  },
  mounted() {
    let self = this;
    const id = this.$route.params.id;
    self.userId = this.$route.params.ids;
    self.currentId = id;
  },
  methods: {
    backToList(userId) {
      if (userId != null) {
        this.$router.push({path: "/profile/all/" + userId});
      }
    },
    getTab(tab) {
      let self = this;
      self.selected = tab;
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
